<template>
    <v-card class="pa-4 elevation-4 rounded-lg" id="group_publications">
        <v-card-title class="title-card">
            <h4>
                <v-icon size="18" class="mx-2">fa-solid fa-layer-group</v-icon>
                {{ edit ? $t('components.views.settings.posting_rules.group_publications.edit_group_publication') :
                    $t('components.views.settings.posting_rules.group_publications.create_group_publication') }}
            </h4>
            <v-spacer />
            <v-btn depressed text color="white" @click.stop="$emit('closeForm')">
                <v-icon small class="mr-1">fa-regular fa-rectangle-xmark</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <!-- Nombre, Estado y Llamada a conductor -->
            <v-row class="mt-2 align-center">
                <v-col cols="6" class="py-2">
                    <v-text-field v-model="publicationName" required
                        :label="$t('components.views.settings.posting_rules.group_publications.name')"
                        :placeholder="$t('components.views.settings.posting_rules.group_publications.name')" outlined
                        dense hide-details />
                </v-col>
                <v-col cols="3" class="py-2 d-flex align-center">
                    <v-switch v-model="publicationStatus"
                        :label="publicationStatus ? $t('components.views.settings.posting_rules.group_publications.active') : $t('components.views.settings.posting_rules.group_publications.inactive')"
                        color="primary" class="mt-0" hide-details />
                </v-col>
                <v-col cols="3" class="py-2 d-flex align-center">
                    <v-switch v-model="callToDriver"
                        :label="$t('components.views.settings.posting_rules.group_publications.call_to_driver')"
                        color="primary" class="mt-0" hide-details />
                </v-col>
            </v-row>

            <!-- Selección de Grupo -->
            <v-row class="mt-2">
                <v-col cols="12" class="py-2">
                    <SelectAutocomplete v-model="selectedGroup" required :data="groupsList" item-text="name"
                        item-value="name" multiple
                        :label="$t('components.views.settings.posting_rules.group_publications.select_group')"
                        :placeholder="$t('components.views.settings.posting_rules.group_publications.select_group')"
                        outlined dense :init="false" :selected="selectedGroup" />
                </v-col>
            </v-row>

            <div id="container_group_publications" class="scroll-design pa-0">
                <v-container class="px-0 ma-0 py-4">
                    <div class="px-5 pt-4 pr-8 fields__container">
                        <!-- Título de Variables dentro del contenedor -->
                        <v-row>
                            <v-col cols="12" class="pb-2">
                                <h2 class="primary--text variables-title">
                                    {{
                                        $t("components.views.settings.posting_rules.group_publications.variables")
                                    }}
                                </h2>
                            </v-col>
                        </v-row>
                        <!-- Primera fila - Solo País -->
                        <v-row>
                            <v-col cols="6">
                                <SelectAutocomplete v-model="variables.pais"
                                    :label="$t('components.views.settings.posting_rules.group_publications.country')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.country')"
                                    outlined dense clearable :init="false" :data="countries" item-text="name"
                                    item-value="idCountry" @change="onCountryChange" :selected="variables.pais" />
                            </v-col>
                        </v-row>

                        <!-- Segunda fila - Departamentos Origen y Destino -->
                        <v-row>
                            <v-col cols="6" class="pr-2">
                                <SelectAutocomplete v-model="variables.departamentoOrigen"
                                    :label="$t('components.views.settings.posting_rules.group_publications.origin_department')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.origin_department')"
                                    outlined dense clearable :init="false" :data="departmentsOrigen" item-text="name"
                                    item-value="idDepartments" @change="onOriginDepartmentChange"
                                    :disabled="!variables.pais" :selected="variables.departamentoOrigen" />
                            </v-col>
                            <v-col cols="6" class="pl-2">
                                <SelectAutocomplete v-model="variables.departamentoDestino"
                                    :label="$t('components.views.settings.posting_rules.group_publications.destination_department')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.destination_department')"
                                    outlined dense clearable :init="false" :data="departmentsDestino" item-text="name"
                                    item-value="idDepartments" @change="onDestinationDepartmentChange"
                                    :disabled="!variables.pais" :selected="variables.departamentoDestino" />
                            </v-col>
                        </v-row>

                        <!-- Cuarta fila de campos - Ciudades -->
                        <v-row>
                            <v-col cols="6" class="pr-2">
                                <SelectAutocomplete v-model="variables.ciudadOrigen"
                                    :label="$t('components.views.settings.posting_rules.group_publications.origin_city')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.origin_city')"
                                    outlined dense clearable :init="false" :data="citiesOrigen" item-text="name"
                                    item-value="idCity" :disabled="!variables.departamentoOrigen"
                                    :selected="variables.ciudadOrigen" />
                            </v-col>
                            <v-col cols="6" class="pl-2">
                                <SelectAutocomplete v-model="variables.ciudadDestino"
                                    :label="$t('components.views.settings.posting_rules.group_publications.destination_city')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.destination_city')"
                                    outlined dense clearable :init="false" :data="citiesDestino" item-text="name"
                                    item-value="idCity" :disabled="!variables.departamentoDestino"
                                    :selected="variables.ciudadDestino" />
                            </v-col>
                        </v-row>

                        <!-- Tercera fila de campos -->
                        <v-row>
                            <v-col cols="6" class="pr-2">
                                <v-autocomplete v-model="variables.tipoOperacion"
                                    :items="operationTypes"
                                    :label="$t('components.views.settings.posting_rules.group_publications.operation_type')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.operation_type')"
                                    outlined dense clearable multiple chips return-object
                                    item-text="description" item-value="description"
                                    :search-input.sync="searchTypeOperation"
                                    :loading="loadingScroll.typeOperation || isSearchingTypeOperation"
                                    :data-scroll-id="'typeOperation'"
                                    @focus="setActiveScroll('typeOperation')" />
                            </v-col>
                            <v-col cols="6" class="pl-2">
                                <SelectAutocomplete v-model="variables.unidadNegocio"
                                    :label="$t('components.views.settings.posting_rules.group_publications.business_unit')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.business_unit')"
                                    outlined dense clearable :init="false" :data="businessUnits" item-text="description"
                                    :returnObject="true" item-value="description" :selected="variables.unidadNegocio" />
                            </v-col>
                        </v-row>

                        <!-- Cuarta fila de campos -->
                        <v-row>
                            <v-col cols="6" class="pr-2">
                                <SelectAutocomplete v-model="variables.canalVentas"
                                    :label="$t('components.views.settings.posting_rules.group_publications.sales_channel')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.sales_channel')"
                                    outlined dense clearable :init="false" :data="salesChannels" item-text="description"
                                    :returnObject="true" item-value="description" :selected="variables.canalVentas" />
                            </v-col>
                            <v-col cols="6" class="pl-2">
                                <v-text-field v-model.number="variables.flete"
                                    :label="$t('components.views.settings.posting_rules.group_publications.freight')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.freight')"
                                    outlined dense clearable type="number" />
                            </v-col>
                        </v-row>

                        <!-- Quinta fila de campos -->
                        <v-row>
                            <v-col cols="6" class="pr-2">
                                <SelectAutocomplete v-model="variables.tipologiaVehiculo"
                                    :label="$t('components.views.settings.posting_rules.group_publications.vehicle_typology')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.vehicle_typology')"
                                    outlined dense clearable :init="false" :data="vehicleTypologies" item-text="name"
                                    :returnObject="true" item-value="name" :selected="variables.tipologiaVehiculo" />
                            </v-col>
                            <v-col cols="6" class="pl-2">
                                <SelectAutocomplete v-model="variables.tipoViaje"
                                    :label="$t('components.views.settings.posting_rules.group_publications.trip_type')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.trip_type')"
                                    outlined dense clearable :init="false" :data="tripTypes" item-text="name"
                                    :returnObject="true" item-value="name" :selected="variables.tipoViaje" />
                            </v-col>
                        </v-row>

                        <!-- Quinta fila de campos -->
                        <v-row>
                            <v-col cols="6" class="pr-2">
                                <SelectAutocomplete v-model="variables.tipoProducto"
                                    :label="$t('components.views.settings.posting_rules.group_publications.product_type')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.product_type')"
                                    outlined dense clearable multiple chips :init="false" :data="productTypes"
                                    item-text="description" item-value="description" :returnObject="true"
                                    :selected="variables.tipoProducto" />
                            </v-col>
                            <v-col cols="6" class="pl-2">
                                <SelectAutocomplete v-model="variables.tipoMercancia"
                                    :label="$t('components.views.settings.posting_rules.group_publications.merchandise_type')"
                                    :placeholder="$t('components.views.settings.posting_rules.group_publications.merchandise_type')"
                                    outlined dense clearable multiple chips :init="false" :data="merchandiseTypes"
                                    item-text="description" item-value="description" :returnObject="true"
                                    :selected="variables.tipoMercancia" />
                            </v-col>
                        </v-row>

                        <!-- Intervalos de publicación (Nueva estructura basada en AutomaticPublications) -->
                        <v-row class="mt-4 actions__add">
                            <v-col cols="8" md="auto" class="mt-0">
                                <h3 class="primary--text">
                                    {{
                                        $t(
                                            'components.views.settings.posting_rules.publications_intervals.intervals'
                                        )
                                    }}
                                </h3>
                            </v-col>
                            <v-spacer />
                            <v-col cols="2">
                                <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                        <v-btn color="primary" depressed block v-bind="attrs" v-on="on"
                                            @click="addFields()" :disabled="lengthFieldsFroms >= 5">
                                            <v-icon size="16">fa-solid fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{
                                        $t(
                                            'components.views.settings.posting_rules.publications_intervals.add_interval'
                                        )
                                    }}</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <div class="pt-2">
                            <div v-for="(fieldFrom, a) in fieldsFroms" :key="'field' + a"
                                class="px-3 pt-4 pr-4 pb-0 fields__container">
                                <v-row>
                                    <v-col cols="12" class="pa-0 fields__actions">
                                        <b class="primary--text pl-3">
                                            {{
                                                $t(
                                                    'components.views.settings.posting_rules.publications_intervals.interval'
                                                )
                                            }}
                                            N° {{ a + 1 }}
                                        </b>
                                        <v-spacer />
                                        <v-col cols="1" class="pa-0 ma-0">
                                            <v-tooltip bottom>
                                                <template #activator="{ on, attrs }">
                                                    <v-btn color="red darken-2 white--text" class="btn-removefields"
                                                        depressed dense block v-bind="attrs" v-on="on"
                                                        @click="removeFields(a)" :disabled="fieldsFroms.length < 1">
                                                        <v-icon size="16">fa-solid fa-minus</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{
                                                    $t(
                                                        'components.views.settings.posting_rules.publications_intervals.delete_interval'
                                                    )
                                                }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-col>
                                </v-row>

                                <!-- Tiempo publicado: Días / Horas -->
                                <v-row>
                                    <v-col cols="auto" class="pb-0 mb-0">
                                        <p class="mt-2 mb-0">
                                            {{
                                                $t(
                                                    'components.views.settings.posting_rules.publications_intervals.published_time'
                                                )
                                            }}:
                                        </p>
                                    </v-col>
                                    <v-col cols="2" class="pb-0">
                                        <v-text-field v-model="fieldFrom.valueDayTimePublic" outlined required :label="$t('components.views.settings.posting_rules.publications_intervals.days')
                                            " dense />
                                    </v-col>
                                    <v-col cols="2" class="pb-0">
                                        <v-text-field v-model="fieldFrom.valueHourTimeDate" outlined required dense
                                            :label="$t('components.views.settings.posting_rules.publications_intervals.hours')
                                                " />
                                    </v-col>
                                </v-row>

                                <!-- Grupos y datos del grupo seleccionado -->
                                <v-row>
                                    <v-col cols="12" class="py-0">
                                        <SelectAutocomplete v-model="fieldFrom.selectedGroups"
                                            :data="filteredGroupsList" item-text="name" item-value="name" outlined dense
                                            chips multiple :label="$t('components.views.settings.posting_rules.group_publications.select_group')
                                                " :placeholder="$t('components.views.settings.posting_rules.group_publications.select_group')
                                                    " :init="false" :selected="fieldFrom.selectedGroups"
                                            @change="onGroupSelectionChange(fieldFrom, a)" />
                                    </v-col>
                                </v-row>
                                <!-- Listas por cada grupo seleccionado (Transport Companies, Drivers, Vehicles) -->
                                <v-row v-for="(gd, gi) in fieldFrom.groupsDetail" :key="`gd-${a}-${gi}`" class="mt-2">
                                    <v-col cols="12" class="py-0">
                                        <h4 class="subtitle-1 mb-2">{{ gd.groupName }}</h4>
                                        <v-row class="pb-2">
                                            <v-col cols="12" md="4" class="py-0">
                                                <SelectAutocomplete v-model="gd.categories.TransportCompanies.selected"
                                                    :data="gd.categories.TransportCompanies.options" item-text="name"
                                                    item-value="id" return-object outlined dense chips multiple
                                                    :label="'Transport Companies'" :placeholder="'Transport Companies'"
                                                    :init="false" :selected="gd.categories.TransportCompanies.selected">
                                                    <template v-slot:prepend-item>
                                                        <v-list-item ripple @mousedown.prevent
                                                            @click="toggleAllCategory(a, gi, 'TransportCompanies')">
                                                            <v-list-item-action>
                                                                <v-icon
                                                                    :class="getIconCategory(a, gi, 'TransportCompanies')" />
                                                            </v-list-item-action>
                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                    {{
                                                                        $t('components.views.settings.posting_rules.publications_intervals.select_all')
                                                                    }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                                        <v-chip v-bind="attrs" :input-value="selected" label small>
                                                            <span class="pr-2">{{ item.name }}</span>
                                                            <v-icon small @click="parent.selectItem(item)"> $delete
                                                            </v-icon>
                                                        </v-chip>
                                                    </template>
                                                </SelectAutocomplete>
                                            </v-col>
                                            <v-col cols="12" md="4" class="py-0">
                                                <SelectAutocomplete v-model="gd.categories.Drivers.selected"
                                                    :data="gd.categories.Drivers.options" item-text="name"
                                                    item-value="id" return-object outlined dense chips multiple
                                                    :label="'Drivers'" :placeholder="'Drivers'" :init="false"
                                                    :selected="gd.categories.Drivers.selected">
                                                    <template v-slot:prepend-item>
                                                        <v-list-item ripple @mousedown.prevent
                                                            @click="toggleAllCategory(a, gi, 'Drivers')">
                                                            <v-list-item-action>
                                                                <v-icon :class="getIconCategory(a, gi, 'Drivers')" />
                                                            </v-list-item-action>
                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                    {{
                                                                        $t('components.views.settings.posting_rules.publications_intervals.select_all')
                                                                    }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                                        <v-chip v-bind="attrs" :input-value="selected" label small>
                                                            <span class="pr-2">{{ item.name }}</span>
                                                            <v-icon small @click="parent.selectItem(item)"> $delete
                                                            </v-icon>
                                                        </v-chip>
                                                    </template>
                                                </SelectAutocomplete>
                                            </v-col>
                                            <v-col cols="12" md="4" class="py-0">
                                                <SelectAutocomplete v-model="gd.categories.Vehicles.selected"
                                                    :data="gd.categories.Vehicles.options" item-text="name"
                                                    item-value="id" return-object outlined dense chips multiple
                                                    :label="'Vehicles'" :placeholder="'Vehicles'" :init="false"
                                                    :selected="gd.categories.Vehicles.selected">
                                                    <template v-slot:prepend-item>
                                                        <v-list-item ripple @mousedown.prevent
                                                            @click="toggleAllCategory(a, gi, 'Vehicles')">
                                                            <v-list-item-action>
                                                                <v-icon :class="getIconCategory(a, gi, 'Vehicles')" />
                                                            </v-list-item-action>
                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                    {{
                                                                        $t('components.views.settings.posting_rules.publications_intervals.select_all')
                                                                    }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                                        <v-chip v-bind="attrs" :input-value="selected" label small>
                                                            <span class="pr-2">{{ item.name }}</span>
                                                            <v-icon small @click="parent.selectItem(item)"> $delete
                                                            </v-icon>
                                                        </v-chip>
                                                    </template>
                                                </SelectAutocomplete>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>

                        <!-- Radio de publicación -->
                        <v-row class="mt-6">
                            <v-col cols="12">
                                <v-card class="group-radius-card pa-6" elevation="2">
                                    <!-- Header con icono y título -->
                                    <div class="d-flex align-center mb-6">
                                        <div class="group-icon-circle">
                                            <v-icon color="white" size="22">fa-solid fa-location-dot</v-icon>
                                        </div>
                                        <div class="ml-3">
                                            <h3 class="group-radius-title mb-0">{{
                                                $t('components.views.settings.posting_rules.group_publications.publication_radius_title')
                                            }}
                                            </h3>
                                            <p class="group-radius-subtitle mb-0 mt-1">{{
                                                $t('components.views.settings.posting_rules.group_publications.adjust_search_area')
                                            }}</p>
                                        </div>
                                        <v-spacer></v-spacer>
                                        <div class="text-right group-value-container">
                                            <div class="group-radius-value">{{ perimeterCustomByGroup }}</div>
                                            <div class="group-radius-unit">{{
                                                $t('components.views.settings.posting_rules.group_publications.kilometers')
                                            }}</div>
                                        </div>
                                    </div>

                                    <!-- Marcadores del slider -->
                                    <div class="group-slider-markers d-flex justify-space-between mb-1 px-1">
                                        <span class="group-marker"
                                            :class="{ 'group-marker-active': perimeterCustomByGroup >= 1 }">
                                            <span class="group-marker-tick"></span>
                                            <span class="group-marker-label">1</span>
                                        </span>
                                        <span class="group-marker"
                                            :class="{ 'group-marker-active': perimeterCustomByGroup >= 100 }">
                                            <span class="group-marker-tick"></span>
                                            <span class="group-marker-label">100</span>
                                        </span>
                                        <span class="group-marker"
                                            :class="{ 'group-marker-active': perimeterCustomByGroup >= 200 }">
                                            <span class="group-marker-tick"></span>
                                            <span class="group-marker-label">200</span>
                                        </span>
                                        <span class="group-marker"
                                            :class="{ 'group-marker-active': perimeterCustomByGroup >= 300 }">
                                            <span class="group-marker-tick"></span>
                                            <span class="group-marker-label">300</span>
                                        </span>
                                        <span class="group-marker"
                                            :class="{ 'group-marker-active': perimeterCustomByGroup >= 400 }">
                                            <span class="group-marker-tick"></span>
                                            <span class="group-marker-label">400</span>
                                        </span>
                                        <span class="group-marker"
                                            :class="{ 'group-marker-active': perimeterCustomByGroup >= 500 }">
                                            <span class="group-marker-tick"></span>
                                            <span class="group-marker-label">500</span>
                                        </span>
                                    </div>

                                    <!-- Slider personalizado -->
                                    <div class="group-custom-slider-container px-1 mb-4">
                                        <v-slider v-model="perimeterCustomByGroup" min="1" max="500" always-dirty
                                            hide-details class="group-custom-slider">
                                        </v-slider>
                                    </div>

                                    <!-- Leyenda -->
                                    <div class="d-flex justify-space-between align-center px-1 mt-2">
                                        <div class="d-flex align-center">
                                            <span class="group-legend-dot group-legend-dot-blue"></span>
                                            <span class="group-legend-text">{{
                                                $t('components.views.settings.posting_rules.group_publications.near')
                                            }}</span>
                                        </div>
                                        <div class="d-flex align-center">
                                            <span class="group-legend-dot group-legend-dot-orange"></span>
                                            <span class="group-legend-text">{{
                                                $t('components.views.settings.posting_rules.group_publications.far')
                                            }}</span>
                                        </div>
                                    </div>

                                    <!-- Mensaje informativo -->
                                    <div class="mt-4">
                                        <div class="group-info-alert">
                                            <div class="d-flex align-start">
                                                <v-icon color="#FF9800" size="20" class="mr-2 flex-shrink-0">fa-solid
                                                    fa-truck</v-icon>
                                                <span class="group-info-text">
                                                    {{
                                                        $t('components.views.settings.posting_rules.group_publications.trip_will_be_published')
                                                    }}
                                                    <strong class="group-info-highlight">{{ perimeterCustomByGroup }}
                                                        km</strong>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </div>
        </v-card-text>
        <v-card-actions class="justify-space-between">
            <v-btn color="grey darken-1" class="white--text" @click="clearFields">
                <v-icon left>fa-solid fa-broom</v-icon>
                {{ $t('components.views.settings.posting_rules.group_publications.clean') }}
            </v-btn>
            <div>
                <v-btn text class="mr-2" @click="$emit('closeForm')">
                    {{ $t('components.views.settings.groups.cancel') }}
                </v-btn>
                <v-btn color="#FF6B35" dark class="rounded-lg" @click="createGroup">
                    <v-icon left>{{ edit ? 'fa-solid fa-save' : 'fa-solid fa-plus' }}</v-icon>
                    {{ edit ? $t('components.views.settings.groups.edit_group_button') :
                        $t('components.views.settings.groups.save_button') }}
                </v-btn>
            </div>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "ModalFormGroupPublication",
    components: {
        SelectAutocomplete: () =>
            import(
        /* webpackChunkName: "SelectAutocomplete" */ "@/components/app/SelectAutocomplete.vue"
            ),
    },
    props: {
        edit: { type: Boolean, default: false },
        data: { type: Object, default: () => ({}) },
    },
    data: () => ({
        publicationName: "",
        publicationStatus: true,
        callToDriver: false,
        selectedGroup: [],
        groupsList: [],
        perimeterCustomByGroup: [],
        variables: {
            pais: null,
            departamentoOrigen: null,
            departamentoDestino: null,
            ciudadOrigen: null,
            ciudadDestino: null,
            tipoOperacion: [],
            unidadNegocio: null,
            canalVentas: null,
            flete: null,
            tipologiaVehiculo: null,
            tipoViaje: null,
            tipoProducto: [],
            tipoMercancia: [],
        },
        countries: [],
        departmentsOrigen: [],
        departmentsDestino: [],
        citiesOrigen: [],
        citiesDestino: [],
        operationTypes: [],
        operationTypePage: 1,
        totalTypeOperationPages: null,
        activeScrollId: null,
        loadingScroll: {
            typeOperation: false,
        },
        searchTypeOperation: "",
        isSearchingTypeOperation: false,
        typeOperationSearchTimeout: null,
        businessUnits: [],
        salesChannels: [],
        vehicleTypologies: [],
        tripTypes: [],
        productTypes: [],
        merchandiseTypes: [],
        // Nueva estructura de intervalos: iniciar vacío (opcional)
        fieldsFroms: [],
    }),
    computed: {
        ...mapGetters({
            user: "auth/user",
        }),
        idCompany() {
            if (this.user) {
                const userMap = JSON.parse(this.user);
                return userMap.user.idCompany;
            }
            return null;
        },
        lengthFieldsFroms() {
            return this.fieldsFroms.length;
        },
        // Lista de grupos filtrada por la selección superior
        filteredGroupsList() {
            const selected = Array.isArray(this.selectedGroup) ? this.selectedGroup : [];
            if (!this.groupsList || this.groupsList.length === 0) return [];
            if (selected.length === 0) return [];
            return this.groupsList.filter(g => selected.includes(g.name));
        },
    },
    watch: {
        searchTypeOperation(value) {
            clearTimeout(this.typeOperationSearchTimeout);
            if (!value) {
                return;
            }

            this.typeOperationSearchTimeout = setTimeout(() => {
                this.loadTypeOperationPagesForSearch(value);
            }, 300);
        },
        // Watcher para recargar datos cuando cambie la prop data
        data: {
            handler(newData) {
                if (this.edit && newData) {
                    this.$nextTick(() => {
                        this.prefillFromData();
                    });
                }
            },
            deep: true,
            immediate: false
        },
        // Watcher para limpiar campos cuando se cambie de edición a creación
        edit(newEdit) {
            if (!newEdit) {
                this.clearFields();
            }
        },
        // Mantener los intervalos en sincronía con los grupos seleccionados arriba
        selectedGroup(newList) {
            const names = Array.isArray(newList) ? newList : [];
            this.fieldsFroms.forEach((f) => {
                const sel = Array.isArray(f.selectedGroups) ? f.selectedGroups : [];
                f.selectedGroups = sel.filter(n => names.includes(n));
                const details = Array.isArray(f.groupsDetail) ? f.groupsDetail : [];
                f.groupsDetail = details.filter(gd => names.includes(gd.groupName));
            });
        }
    },
    methods: {
        ...mapActions("loader", ["showLoader"]),
        ...mapActions("snackbar", ["showSnack"]),
        // Nueva gestión de intervalos
        addFields() {
            if (this.fieldsFroms.length < 5) {
                this.fieldsFroms.push({
                    valueDayTimePublic: 0,
                    valueHourTimeDate: 0,
                    selectedGroups: [],
                    groupsDetail: [],
                });
            }
        },

        removeFields(index) {
            // Permitir eliminar incluso el último intervalo (puede quedar en cero)
            if (index >= 0 && index < this.fieldsFroms.length) {
                this.fieldsFroms.splice(index, 1);
            }
        },

        onGroupSelectionChange(fieldFrom, index) {
            const selectedNames = Array.isArray(fieldFrom.selectedGroups) ? fieldFrom.selectedGroups : [];

            // Mantener solo los detalles de grupos seleccionados
            fieldFrom.groupsDetail = (fieldFrom.groupsDetail || []).filter(gd => selectedNames.includes(gd.groupName));

            // Crear/actualizar detalle por cada grupo con categorías usando datos reales de groupsList
            selectedNames.forEach((name) => {
                const groupObj = (this.groupsList || []).find(g => g && g.name === name);
                const members = (groupObj && groupObj.members) ? groupObj.members : {};
                const tcOpts = (members.transportCompanies || []).map(tc => ({ id: tc.id, name: tc.name }));
                const drOpts = (members.drivers || []).map(dr => ({ id: dr.id, name: dr.name }));
                // Para vehículos mostramos el licensePlate
                const vhOpts = (members.vehicles || []).map(vh => ({ id: vh.id, name: vh.licensePlate }));

                const existing = (fieldFrom.groupsDetail || []).find(gd => gd.groupName === name);
                if (existing) {
                    // Actualizar opciones manteniendo seleccionados válidos
                    const cats = existing.categories || {};
                    const upd = (catKey, opts) => {
                        const sel = (cats[catKey] && cats[catKey].selected) ? cats[catKey].selected : [];
                        if (cats[catKey]) {
                            cats[catKey].options = opts;
                            cats[catKey].selected = sel.filter(s => opts.some(o => o.id === (s.id || s)));
                        }
                    };
                    upd('TransportCompanies', tcOpts);
                    upd('Drivers', drOpts);
                    upd('Vehicles', vhOpts);
                } else {
                    fieldFrom.groupsDetail.push({
                        groupName: name,
                        categories: {
                            TransportCompanies: { options: tcOpts, selected: [] },
                            Drivers: { options: drOpts, selected: [] },
                            Vehicles: { options: vhOpts, selected: [] },
                        },
                    });
                }
            });
        },

        toggleAllCategory(index, groupIndex, categoryKey) {
            const gd = (this.fieldsFroms[index].groupsDetail || [])[groupIndex];
            if (!gd || !gd.categories || !gd.categories[categoryKey]) return;
            const opts = gd.categories[categoryKey].options || [];
            const selected = gd.categories[categoryKey].selected || [];
            gd.categories[categoryKey].selected = selected.length === opts.length ? [] : opts.slice();
        },

        getIconCategory(index, groupIndex, categoryKey) {
            const gd = (this.fieldsFroms[index].groupsDetail || [])[groupIndex];
            if (!gd || !gd.categories || !gd.categories[categoryKey]) return 'fa-solid fa-square';
            const opts = gd.categories[categoryKey].options || [];
            const selected = gd.categories[categoryKey].selected || [];
            if (selected.length === opts.length && opts.length > 0) return 'fa-solid fa-square-check';
            if (selected.length > 0) return 'fa-solid fa-square-minus';
            return 'fa-solid fa-square';
        },

        async onCountryChange() {
            this.variables.departamentoOrigen = null;
            this.variables.departamentoDestino = null;
            this.variables.ciudadOrigen = null;
            this.variables.ciudadDestino = null;
            this.departmentsOrigen = [];
            this.departmentsDestino = [];
            this.citiesOrigen = [];
            this.citiesDestino = [];

            if (this.variables.pais) {
                await this.loadDepartmentsOrigen(this.variables.pais);
                await this.loadDepartmentsDestino(this.variables.pais);
            }
        },

        async onOriginDepartmentChange() {
            this.variables.ciudadOrigen = null;
            this.citiesOrigen = [];

            if (this.variables.departamentoOrigen) {
                await this.loadCitiesOrigen(this.variables.departamentoOrigen);
            }
        },

        async onDestinationDepartmentChange() {
            this.variables.ciudadDestino = null;
            this.citiesDestino = [];

            if (this.variables.departamentoDestino) {
                await this.loadCitiesDestino(this.variables.departamentoDestino);
            }
        },

        async loadCountries() {
            try {
                const response = await this.axios.get('/Country/GetAll');
                this.countries = response.data || [];
            } catch (error) {
                console.error('Error loading countries:', error);
                this.countries = [];
            }
        },

        async loadDepartmentsOrigen(countryId) {
            try {
                const response = await this.axios.get(`/Departments/GetByCountry/${countryId}`);
                this.departmentsOrigen = response.data || [];
            } catch (error) {
                console.error('Error loading origin departments:', error);
                this.departmentsOrigen = [];
            }
        },

        async loadDepartmentsDestino(countryId) {
            try {
                const response = await this.axios.get(`/Departments/GetByCountry/${countryId}`);
                this.departmentsDestino = response.data || [];
            } catch (error) {
                console.error('Error loading destination departments:', error);
                this.departmentsDestino = [];
            }
        },

        async loadCitiesOrigen(departmentId) {
            try {
                const response = await this.axios.get(`/City/ByIdDepartment/${departmentId}`);
                this.citiesOrigen = response.data || [];
            } catch (error) {
                console.error('Error loading origin cities:', error);
                this.citiesOrigen = [];
            }
        },

        async loadCitiesDestino(departmentId) {
            try {
                const response = await this.axios.get(`/City/ByIdDepartment/${departmentId}`);
                this.citiesDestino = response.data || [];
            } catch (error) {
                console.error('Error loading destination cities:', error);
                this.citiesDestino = [];
            }
        },

        setActiveScroll(id) {
            this.activeScrollId = id;
            this.pollForDropdownScrollListener(id);
        },

        pollForDropdownScrollListener(id) {
            const interval = setInterval(() => {
                const menus = document.querySelectorAll('.v-menu__content');

                menus.forEach((menu) => {
                    const alreadyAttached = menu.dataset[`scrollAttached_${id}`];
                    if (alreadyAttached) return;
                    if (this.activeScrollId !== id) return;

                    menu.dataset[`scrollAttached_${id}`] = 'true';
                    menu.addEventListener('scroll', (e) => this.handleScroll(e, id));
                });
            }, 500);

            setTimeout(() => {
                clearInterval(interval);
            }, 5000);
        },

        handleScroll(e, id) {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            const preloadMargin = 50;

            if (scrollTop + clientHeight >= scrollHeight - preloadMargin) {
                if (this.loadingScroll[id] || this.isSearchingTypeOperation) {
                    return;
                }

                this.loadingScroll[id] = true;

                if (id === 'typeOperation') {
                    if (!this.totalTypeOperationPages || this.operationTypePage < this.totalTypeOperationPages) {
                        this.operationTypePage++;
                        this.loadOperationTypes().finally(() => {
                            this.loadingScroll[id] = false;
                        });
                    } else {
                        this.loadingScroll[id] = false;
                    }
                }
            }
        },

        async loadOperationTypes() {
            try {
                const size = 50;
                const res = await this.axios.get(`/TypeOperation/GetAsyncTypeOperationGET/${this.idCompany}/${this.operationTypePage}/${size}`);
                const data = res.data || [];

                if (data.length < size) {
                    this.totalTypeOperationPages = this.operationTypePage;
                }

                this.operationTypes.push(...data);
            } catch (error) {
                console.error('Error loading operation types:', error);
            }
        },

        async loadTypeOperationPagesForSearch(searchValue) {
            if (!searchValue) {
                return;
            }

            if (this.isSearchingTypeOperation) {
                this.typeOperationSearchTimeout = setTimeout(() => {
                    this.loadTypeOperationPagesForSearch(searchValue);
                }, 300);
                return;
            }

            this.isSearchingTypeOperation = true;
            const currentSearch = searchValue;

            try {
                while (
                    this.searchTypeOperation === currentSearch &&
                    (!this.totalTypeOperationPages || this.operationTypePage < this.totalTypeOperationPages)
                ) {
                    this.operationTypePage++;
                    await this.loadOperationTypes();
                }
            } finally {
                this.isSearchingTypeOperation = false;
            }
        },

        async loadBusinessUnits() {
            try {
                const res = await this.axios.get(`/BusinessUnits/ByIdCompay/${this.idCompany}`);
                this.businessUnits = res.data || [];
            } catch (error) {
                console.error('Error loading business units:', error);
                this.businessUnits = [];
            }
        },

        async loadSalesChannels() {
            try {
                const res = await this.axios.get(`/Channel/ByIdCompay/${this.idCompany}`);
                this.salesChannels = res.data || [];
            } catch (error) {
                console.error('Error loading sales channels:', error);
                this.salesChannels = [];
            }
        },

        async loadVehicleTypologies() {
            try {
                const res = await this.axios.get(`/Vehicles/vehicleTypologyList`);
                this.vehicleTypologies = res.data || [];
            } catch (error) {
                console.error('Error loading vehicle typologies:', error);
                this.vehicleTypologies = [];
            }
        },

        async loadTripTypes() {
            try {
                const res = await this.axios.get(`/TypeTrip`);
                this.tripTypes = res.data || [];
            } catch (error) {
                console.error('Error loading trip types:', error);
                this.tripTypes = [];
            }
        },

        async loadProductTypes() {
            try {
                const res = await this.axios.get(`/Product/TypeProduct/${this.idCompany}`);
                this.productTypes = res.data || [];
            } catch (error) {
                console.error('Error loading product types:', error);
                this.productTypes = [];
            }
        },

        async loadMerchandiseTypes() {
            try {
                const res = await this.axios.get(`/Merchandise/GetAll/${this.idCompany}`);
                this.merchandiseTypes = res.data || [];
            } catch (error) {
                console.error('Error loading merchandise types:', error);
                this.merchandiseTypes = [];
            }
        },

        clearFields() {
            // Reiniciar nombre y estado
            this.publicationName = "";
            this.publicationStatus = true;
            this.callToDriver = false;
            this.perimeterCustomByGroup = [];

            // Reiniciar selección de grupo
            this.selectedGroup.splice(0, this.selectedGroup.length);
            this.variables = {
                pais: null,
                departamentoOrigen: null,
                departamentoDestino: null,
                ciudadOrigen: null,
                ciudadDestino: null,
                tipoOperacion: [],
                unidadNegocio: null,
                canalVentas: null,
                flete: null,
                tipologiaVehiculo: null,
                tipoViaje: null,
                tipoProducto: [],
                tipoMercancia: [],
            };
            this.countries = [];
            this.departmentsOrigen = [];
            this.departmentsDestino = [];
            this.citiesOrigen = [];
            this.citiesDestino = [];
            this.operationTypes = [];
            this.operationTypePage = 1;
            this.totalTypeOperationPages = null;
            this.searchTypeOperation = "";
            this.loadingScroll.typeOperation = false;
            this.businessUnits = [];
            this.salesChannels = [];
            this.vehicleTypologies = [];
            this.tripTypes = [];
            this.productTypes = [];
            this.merchandiseTypes = [];
            // Reiniciar intervalos a vacío
            this.fieldsFroms = [];
        },

        async createGroup() {
            try {
                // Validar nombre y grupos seleccionados
                if (!this.publicationName || !this.publicationName.toString().trim()) {
                    this.showSnack({
                        text: this.$t('components.views.settings.posting_rules.group_publications.name'),
                        title: this.$t('components.views.settings.groups.error'),
                        name: 'warning',
                    });
                    return;
                }
                if (!this.selectedGroup || this.selectedGroup.length === 0) {
                    this.showSnack({
                        text: this.$t('components.views.settings.posting_rules.group_publications.select_group'),
                        title: this.$t('components.views.settings.groups.error'),
                        name: 'warning',
                    });
                    return;
                }
                // Ubicación (país/departamentos/ciudades) ahora es opcional

                // Obtener nombres de las ubicaciones seleccionadas
                const countryName = this.variables.pais ?
                    (this.countries.find(c => c.idCountry === this.variables.pais)?.name || null) : null;

                const originDepartmentName = this.variables.departamentoOrigen ?
                    (this.departmentsOrigen.find(d => d.idDepartments === this.variables.departamentoOrigen)?.name || null) : null;

                const destinationDepartmentName = this.variables.departamentoDestino ?
                    (this.departmentsDestino.find(d => d.idDepartments === this.variables.departamentoDestino)?.name || null) : null;

                const originCityObj = this.variables.ciudadOrigen
                    ? (this.citiesOrigen.find(c => c.idCity === this.variables.ciudadOrigen) || null)
                    : null;

                const destinationCityObj = this.variables.ciudadDestino
                    ? (this.citiesDestino.find(c => c.idCity === this.variables.ciudadDestino) || null)
                    : null;

                const originCityName = originCityObj ? (originCityObj.name || null) : null;
                const destinationCityName = destinationCityObj ? (destinationCityObj.name || null) : null;

                const originCodeCity = originCityObj ? (originCityObj.codeCity || null) : null;
                const destinationCodeCity = destinationCityObj ? (destinationCityObj.codeCity || null) : null;

                // Construir el payload según la entidad PublicationsByGroup
                const getText = (val, key) => {
                    if (val == null) return null;
                    if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') return val;
                    return val[key] != null ? val[key] : null;
                };
                const getFromObj = (val, ...keys) => {
                    if (val == null || typeof val !== 'object') return null;
                    for (const k of keys) {
                        if (val[k] != null) return val[k];
                    }
                    return null;
                };
                const payload = {
                    idCompany: this.idCompany,
                    name: this.publicationName,
                    status: this.publicationStatus ? "Activo" : "Inactivo",
                    callToDriver: this.callToDriver,
                    selectedGroups: this.selectedGroup,
                    country: countryName,
                    originDepartment: originDepartmentName,
                    destinationDepartment: destinationDepartmentName,
                    originCity: originCityName,
                    destinationCity: destinationCityName,
                    originCodeCity,
                    destinationCodeCity,
                    operationType: (this.variables.tipoOperacion || []).map((x) => ({
                        Description: getFromObj(x, 'description', 'Description'),
                        IdOperationTypeWS: getFromObj(x, 'id_operationType_WS', 'IdOperationTypeWS', 'idOperationTypeWS'),
                    })),
                    businessUnit: getText(this.variables.unidadNegocio, 'description'),
                    codeBusinessUnitWS: this.variables.unidadNegocio ? (getFromObj(this.variables.unidadNegocio, 'codeBusinessUnitWS') ?? null) : null,
                    salesChannel: getText(this.variables.canalVentas, 'description'),
                    codeChannelWS: this.variables.canalVentas ? (getFromObj(this.variables.canalVentas, 'code_channel_WS', 'codeChannelWS') ?? null) : null,
                    freight: this.variables.flete != null ? Number(this.variables.flete) : null,
                    vehicleTypology: getText(this.variables.tipologiaVehiculo, 'name'),
                    idVehicleTypology: this.variables.tipologiaVehiculo ? (getFromObj(this.variables.tipologiaVehiculo, 'idVehicleTypology') ?? null) : null,
                    tripType: getText(this.variables.tipoViaje, 'name'),
                    idTypeTrip: this.variables.tipoViaje ? (getFromObj(this.variables.tipoViaje, 'idTypeTrip') ?? null) : null,
                    productType: (this.variables.tipoProducto || []).map((x) => ({
                        Description: getFromObj(x, 'description', 'Description'),
                        CodeTipoProducto: getFromObj(x, 'code', 'CodeTipoProducto'),
                    })),
                    merchandiseType: (this.variables.tipoMercancia || []).map((x) => ({
                        Description: getFromObj(x, 'description', 'Description'),
                        CodeTipoMercancia: getFromObj(x, 'code', 'CodeTipoMercancia'),
                    })),
                    perimeterCustomByGroup: Number(this.perimeterCustomByGroup) * 1000,
                    // Alinear con PublicationIntervals del backend
                    publicationIntervals: this.fieldsFroms.map((f) => ({
                        timePublic: Number(f.valueDayTimePublic) * 24 + Number(f.valueHourTimeDate),
                        groups: f.selectedGroups,
                        groupMembersByGroup: (f.groupsDetail || []).map(gd => ({
                            groupName: gd.groupName,
                            TransportCompanies: (gd.categories.TransportCompanies.selected || []).map(x => ({ id: x.id, name: x.name })),
                            Drivers: (gd.categories.Drivers.selected || []).map(x => ({ id: x.id, name: x.name })),
                            Vehicles: (gd.categories.Vehicles.selected || []).map(x => ({ id: x.id, name: x.name })),
                        })),
                    })),
                };

                // Si estamos editando, incluir id si está disponible
                if (this.edit && this.data && (this.data.id || this.data._id)) {
                    payload.id = this.data.id || this.data._id;
                }

                // Mostrar loader
                this.showLoader({ show: true });

                // Realizar la petición POST
                await this.axios
                    .post("/PublicationsGroups/save", payload, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                    .then(() => {
                        this.showSnack({
                            text: this.edit
                                ? this.$t("components.views.settings.posting_rules.group_publications.success_update")
                                : this.$t("components.views.settings.posting_rules.group_publications.success_save"),
                            title: this.$t("components.views.settings.groups.success"),
                            name: "success",
                        });
                        this.$emit('reloadTable');
                        this.$emit('closeForm');
                    });

                this.clearFields();

            } catch (error) {
                this.showSnack({
                    text:
                        error.response?.data ||
                        this.$t("components.views.settings.groups.error_saving_group"),
                    title: this.$t("components.views.settings.groups.error"),
                    name: "error",
                });
            } finally {
                this.showLoader({ show: false });
            }
        },

        async loadGroups() {
            try {
                const response = await this.axios.get('/Groups/groupsByIdCompany');
                this.groupsList = Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                console.error('Error loading groups:', error);
                this.groupsList = [];
            }
        },

        async prefillFromData() {
            if (!this.data) return;
            const norm = (s) => (s || '').toString().trim();
            const normLower = (s) => norm(s).toLowerCase();
            try {
                console.log("this.data: ", this.data);
                // Cargar nombre y estado
                this.publicationName = this.data.name || "";
                this.publicationStatus = this.data.status === "Activo" || this.data.status === true;
                this.callToDriver = this.data.callToDriver || false;
                this.perimeterCustomByGroup = this.data.perimeterCustomByGroup != null ? Number(this.data.perimeterCustomByGroup) / 1000 : 371;

                if (Array.isArray(this.data.selectedGroups)) {
                    this.selectedGroup = [...this.data.selectedGroups];
                }

                const resolveBy = (items, matchers) => {
                    const list = Array.isArray(items) ? items : [];
                    for (const m of matchers) {
                        const found = list.find(m);
                        if (found) return found;
                    }
                    return null;
                };

                const resolveOperacion = (raw) => {
                    if (!raw) return null;
                    const id = raw.id_operationType_WS ?? raw.IdOperationTypeWS ?? raw.idOperationTypeWS;
                    const desc = raw.description ?? raw.Description ?? null;
                    const found = resolveBy(this.operationTypes, [
                        (x) => (x && (x.id_operationType_WS ?? x.IdOperationTypeWS) != null) && ((x.id_operationType_WS ?? x.IdOperationTypeWS) === id),
                        (x) => normLower(x?.description) && normLower(x?.description) === normLower(desc),
                    ]);
                    return found || (desc || id != null ? { description: desc, id_operationType_WS: id } : null);
                };

                const resolveBusinessUnit = () => {
                    const code = this.data.codeBusinessUnitWS ?? this.data.CodeBusinessUnitWS ?? null;
                    const desc = this.data.businessUnit ?? this.data.BusinessUnit ?? null;
                    const found = resolveBy(this.businessUnits, [
                        (x) => code != null && (x && x.codeBusinessUnitWS === code),
                        (x) => normLower(x?.description) && normLower(x?.description) === normLower(desc),
                    ]);
                    return found || null;
                };

                const resolveSalesChannel = () => {
                    const code = this.data.codeChannelWS ?? this.data.CodeChannelWS ?? null;
                    const desc = this.data.salesChannel ?? this.data.SalesChannel ?? null;
                    const found = resolveBy(this.salesChannels, [
                        (x) => code != null && (x && ((x.code_channel_WS ?? x.codeChannelWS) === code)),
                        (x) => normLower(x?.description) && normLower(x?.description) === normLower(desc),
                    ]);
                    return found || null;
                };

                const resolveVehicleTypology = () => {
                    const id = this.data.idVehicleTypology ?? this.data.IdVehicleTypology ?? null;
                    const name = this.data.vehicleTypology ?? this.data.VehicleTypology ?? null;
                    const found = resolveBy(this.vehicleTypologies, [
                        (x) => id != null && x && x.idVehicleTypology === id,
                        (x) => normLower(x?.name) && normLower(x?.name) === normLower(name),
                    ]);
                    return found || null;
                };

                const resolveTripType = () => {
                    const id = this.data.idTypeTrip ?? this.data.IdTypeTrip ?? null;
                    const name = this.data.tripType ?? this.data.TripType ?? null;
                    const found = resolveBy(this.tripTypes, [
                        (x) => id != null && x && x.idTypeTrip === id,
                        (x) => normLower(x?.name) && normLower(x?.name) === normLower(name),
                    ]);
                    return found || null;
                };

                const resolveProduct = (raw) => {
                    if (!raw) return null;
                    const code = raw.code ?? raw.CodeTipoProducto ?? null;
                    const desc = raw.description ?? raw.Description ?? null;
                    const found = resolveBy(this.productTypes, [
                        (x) => code != null && x && x.code === code,
                        (x) => normLower(x?.description) && normLower(x?.description) === normLower(desc),
                    ]);
                    return found || (desc || code != null ? { description: desc, code } : null);
                };

                const resolveMerchandise = (raw) => {
                    if (!raw) return null;
                    const code = raw.code ?? raw.CodeTipoMercancia ?? null;
                    const desc = raw.description ?? raw.Description ?? null;
                    const found = resolveBy(this.merchandiseTypes, [
                        (x) => code != null && x && x.code === code,
                        (x) => normLower(x?.description) && normLower(x?.description) === normLower(desc),
                    ]);
                    return found || (desc || code != null ? { description: desc, code } : null);
                };

                const rawOperation = Array.isArray(this.data.operationType)
                    ? this.data.operationType
                    : (this.data.operationType ? [this.data.operationType] : []);

                this.variables.tipoOperacion = rawOperation.map(resolveOperacion).filter(Boolean);
                this.variables.unidadNegocio = resolveBusinessUnit();
                this.variables.canalVentas = resolveSalesChannel();
                this.variables.flete = this.data.freight != null ? Number(this.data.freight) : null;
                this.variables.tipologiaVehiculo = resolveVehicleTypology();
                this.variables.tipoViaje = resolveTripType();

                const rawProductTypes = Array.isArray(this.data.productType)
                    ? this.data.productType
                    : (this.data.productType ? [this.data.productType] : []);
                const rawMerchandiseTypes = Array.isArray(this.data.merchandiseType)
                    ? this.data.merchandiseType
                    : (this.data.merchandiseType ? [this.data.merchandiseType] : []);

                this.variables.tipoProducto = rawProductTypes.map(resolveProduct).filter(Boolean);
                this.variables.tipoMercancia = rawMerchandiseTypes.map(resolveMerchandise).filter(Boolean);
                // Prefill de intervalos con la nueva estructura
                const intervals = (this.data.publicationIntervals || this.data.PublicationIntervals || []);
                if (Array.isArray(intervals) && intervals.length) {
                    this.fieldsFroms = intervals.map((pi) => {
                        const tp = Number(pi.timePublic || pi.TimePublic || 0);
                        const days = Math.floor(tp / 24);
                        const hours = tp % 24;
                        const selGroups = Array.isArray(pi.groups || pi.Groups) ? [...(pi.groups || pi.Groups)] : [];
                        const details = [];

                        const gmbgList = (pi.groupMembersByGroup || pi.GroupMembersByGroup || []);
                        gmbgList.forEach((g) => {
                            const name = g.groupName || g.GroupName || '';
                            // Soportar claves en minúscula y mayúscula
                            const tcSelRaw = g.transportCompanies || g.TransportCompanies || [];
                            const drSelRaw = g.drivers || g.Drivers || [];
                            const vhSelRaw = g.vehicles || g.Vehicles || [];
                            const tcSel = tcSelRaw.map(x => ({ id: x.id || x.Id, name: x.name || x.Name })).filter(x => x.id != null);
                            const drSel = drSelRaw.map(x => ({ id: x.id || x.Id, name: x.name || x.Name })).filter(x => x.id != null);
                            // Para vehículos, usar licensePlate si está disponible
                            const vhSel = vhSelRaw.map(x => ({ id: x.id || x.Id, name: x.licensePlate || x.LicensePlate || x.name || x.Name })).filter(x => x.id != null);

                            // Construir opciones desde groupsList si está disponible
                            const groupObj = (this.groupsList || []).find(gr => gr && gr.name === name);
                            const members = (groupObj && groupObj.members) ? groupObj.members : {};
                            const tcOpts = (members.transportCompanies || []).map(tc => ({ id: tc.id, name: tc.name }));
                            const drOpts = (members.drivers || []).map(dr => ({ id: dr.id, name: dr.name }));
                            const vhOpts = (members.vehicles || []).map(vh => ({ id: vh.id, name: vh.licensePlate }));
                            const optsMap = { TransportCompanies: tcOpts.length ? tcOpts : tcSel, Drivers: drOpts.length ? drOpts : drSel, Vehicles: vhOpts.length ? vhOpts : vhSel };
                            details.push({
                                groupName: name,
                                categories: {
                                    TransportCompanies: { options: optsMap.TransportCompanies || [], selected: tcSel },
                                    Drivers: { options: optsMap.Drivers || [], selected: drSel },
                                    Vehicles: { options: optsMap.Vehicles || [], selected: vhSel },
                                },
                            });
                        });

                        return {
                            valueDayTimePublic: days,
                            valueHourTimeDate: hours,
                            selectedGroups: selGroups,
                            groupsDetail: details,
                        };
                    });
                } else {
                    // No agregar intervalos por defecto; mantener vacío
                    this.fieldsFroms = [];
                }
                if (this.data.country && this.countries.length > 0) {
                    const country = this.countries.find(c => norm(c.name) === norm(this.data.country));
                    if (country) {
                        this.variables.pais = country.idCountry;
                        await this.onCountryChange();
                        await this.$nextTick();
                        if (this.data.originDepartment && this.departmentsOrigen.length > 0) {
                            const depO = this.departmentsOrigen.find(d => norm(d.name) === norm(this.data.originDepartment));
                            if (depO) {
                                this.variables.departamentoOrigen = depO.idDepartments;
                                await this.onOriginDepartmentChange();
                                await this.$nextTick();
                                if (this.data.originCity && this.citiesOrigen.length > 0) {
                                    const cityO = this.citiesOrigen.find(c => norm(c.name) === norm(this.data.originCity));
                                    if (cityO) this.variables.ciudadOrigen = cityO.idCity;
                                }
                            }
                        }
                        if (this.data.destinationDepartment && this.departmentsDestino.length > 0) {
                            const depD = this.departmentsDestino.find(d => norm(d.name) === norm(this.data.destinationDepartment));
                            if (depD) {
                                this.variables.departamentoDestino = depD.idDepartments;
                                await this.onDestinationDepartmentChange();
                                await this.$nextTick();
                                if (this.data.destinationCity && this.citiesDestino.length > 0) {
                                    const cityD = this.citiesDestino.find(c => norm(c.name) === norm(this.data.destinationCity));
                                    if (cityD) this.variables.ciudadDestino = cityD.idCity;
                                }
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('Error prefilling data:', error);
                this.showSnack({
                    text: 'Error al cargar los datos para edición',
                    title: this.$t("components.views.settings.groups.error"),
                    name: "error",
                });
            }
        },
    },

    async mounted() {
        await this.loadCountries();
        await this.loadGroups();
        await Promise.all([
            this.loadOperationTypes(),
            this.loadBusinessUnits(),
            this.loadSalesChannels(),
            this.loadVehicleTypologies(),
            this.loadTripTypes(),
            this.loadProductTypes(),
            this.loadMerchandiseTypes(),
        ]);
        if (this.edit && this.data) {
            await this.prefillFromData();
        }
    },
    beforeDestroy() {
        clearTimeout(this.typeOperationSearchTimeout);
    },
};
</script>

<style scoped>
@import "./ModalFormGroupPublicationStyle.scss";
</style>

<style scoped>
/* Estilos específicos del v-slider para el radio de publicación */
.group-custom-slider>>>.v-slider {
    margin-left: 0;
    margin-right: 0;
}

.group-custom-slider>>>.v-slider__track-container {
    height: 6px;
    border-radius: 3px;
}

.group-custom-slider>>>.v-slider__track-background {
    background: #E8E8E8 !important;
    border-radius: 3px;
}

.group-custom-slider>>>.v-slider__track-fill {
    background: linear-gradient(90deg, #0b0045 0%, #3d1a7a 30%, #f05a24 70%, #ff8c5a 100%) !important;
    border-radius: 3px;
}

.group-custom-slider>>>.v-slider__thumb {
    width: 28px !important;
    height: 28px !important;
    background-color: #f05a24 !important;
    border: 5px solid white !important;
    box-shadow: 0 3px 10px rgba(240, 90, 36, 0.35) !important;
    transition: all 0.2s ease;
}

.group-custom-slider>>>.v-slider__thumb::before {
    display: none;
}

.group-custom-slider>>>.v-slider__thumb:hover {
    transform: scale(1.08);
    box-shadow: 0 4px 14px rgba(240, 90, 36, 0.45) !important;
}

.group-custom-slider>>>.v-slider__thumb-container {
    transition: none;
}
</style>
